import { render, staticRenderFns } from "./StaffItem.vue?vue&type=template&id=7969a7d2&scoped=true&"
import script from "./StaffItem.vue?vue&type=script&lang=js&"
export * from "./StaffItem.vue?vue&type=script&lang=js&"
import style0 from "./StaffItem.vue?vue&type=style&index=0&id=7969a7d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7969a7d2",
  null
  
)

export default component.exports